<template>
  <div class="new-pay">
    <!-- <div
      v-show="settingsShow.length > 4 && paySettingStatus === 'right'"
      @click="changePaySettingStatus(0)"
      class="promotion-arrow promotion-left"
    /> -->
    <div class="pay-list">
      <img
        v-show="currentPage > 1"
        :src="require('@/assets/icons/arrow-left.svg')"
        @click="prev"
        class="arrow-left arrow-button"
        alt=""
      >
      <div
        ref="listRef"
        class="pay-wrap"
      >
        <ul>
          <li
            v-for="(i, idx) in settingsShow"
            :key="i.id"
            class="pay-item"
          >
            <div
              :class="{ active: isActive === idx }"
              @click="selPrice(idx, i.id, i)"
              @mouseenter="changeIsDiamondHoverTip(i.month_length === 1200 ? true : false)"
              @mouseleave="changeIsDiamondHoverTip(false)"
            >
              <!-- 默认 默认文案小标 1什么都不展示 2倒计时 3图片 -->
              <span v-if="i.title_type === 1" />
              <span
                v-else-if="!i.title_type && i.title"
                class="tit sprite-icon sprite-icon-pay-title"
              >
                {{ i.title }}
              </span>
              <div
                v-else-if="i.title_type === 2"
                class="tit-time-limit"
              >
                <span
                  v-if="coutTimeNum.end"
                  class="tit"
                >{{ i.title }}</span>
                <div v-else>
                  <div class="time-limit sprite-icon sprite-icon-counter">
                    <span class="limit-title">
                      限时<em class="time-em">:</em>
                    </span>
                    <span class="time-span">{{ coutTimeNum.h }}</span>
                    <em class="time-em">:</em>
                    <span class="time-span">{{ coutTimeNum.m }}</span>
                    <em class="time-em">:</em>
                    <span class="time-span">{{ coutTimeNum.s }}</span>
                  </div>
                </div>
              </div>
              <div
                v-else-if="i.title_type === 3 && i.title_img"
                class="tit-img-3"
              >
                <img :src="i.title_img">
              </div>
              <div
                v-else-if="i.title_img"
                class="tit-img-4"
              >
                <img :src="i.title_img">
              </div>
              <!-- end 默认 默认文案小标 1什么都不展示 2倒计时 3图片 -->
              <p class="current-price">
                <em>￥</em>{{ i.current_price }}
              </p>
              <p class="time-line">
                {{ i.description }}
              </p>
              <div class="linear" />
              <p
                :class="tipClass[i.bottom_type]"
                class="tip"
              >
                {{ i.bottom }}
              </p>
              <em class="active-hook" />
            </div>
          </li>
        </ul>
      </div>
      <img
        v-show="currentPage !== pageCount"
        :src="require('@/assets/icons/arrow-right.svg')"
        @click="next"
        class="arrow-right arrow-button"
        alt=""
      >
    </div>
    <!-- 钻石hover tip -->
    <div
      v-if="isDiamondHoverTip"
      class="tip-wrap"
    >
      <p>专属会员标识〝<em class="diamond-icon" />〞</p>
      <p>资深电脑专家1对1服务</p>
      <div class="arrow" />
      <div class="arrow arrow-white" />
    </div>
    <!-- end 钻石hover tip -->
    <!-- <div
      v-show="settingsShow.length > 4 && paySettingStatus === 'left'"
      @click="changePaySettingStatus(settingsShow.length)"
      class="promotion-arrow promotion-right"
    /> -->

    <!-- 套餐底部提示 -->
    <div class="bottom-desc">
      <!-- 续费套餐提示 -->
      <div
        v-if="continuousText"
        class="renew-text"
      >
        {{ continuousText }}
      </div>
      <slot
        v-else
        name="setting-tip"
      />
    </div>

    <slot name="hasQrcode" />
    <div
      v-if="isActive !== false && !$slots.hasQrcode"
      class="bottom clearfix"
    >
      <dl class="pay_type">
        <dd>
          <span
            @click="selPayType(1)"
            class="wechatpay sprite-icon sprite-icon-wechatpay"
          />
          <div
            v-if="settingsShow[isActive] && settingsShow[isActive].month_length === 1200"
            class="diamond-desc"
          >
            <p class="title">
              钻石VIP专享
            </p>
            <p><i />专属会员标识〝<em class="diamond-icon" />〞</p>
            <p><i />资深电脑专家1对1服务</p>
          </div>
        </dd>
      </dl>
      <div>
        <div class="qrcode">
          <img
            v-if="!loginStatus || isExpires"
            @click="login(9)"
            src="@/assets/images/qrcode.png"
            alt
          >
          <qrcode-vue
            v-else
            :value="qrText"
            :size="110"
            level="H"
          />
        </div>
        <dl class="dl_total">
          <dd>
            <span class="total">
              <em>￥</em>{{ total }}
              <span class="total_off">(已优惠 {{ priceOff }} 元)</span>
            </span>
          </dd>
          <dd>
            <span class="pay-title">使用<em>微信</em>APP扫码完成支付</span>
          </dd>
          <dd>
            <span class="pay-title">开通会员可开发票</span>
          </dd>
          <dd>
            <span class="pay-title">
              开通前请阅读并同意
              <a
                :href="subscribePolicy"
                target="_blank"
              >《订阅协议》</a>
            </span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { getPaySetting, getH5PayResult, cacheH5PageReportParams, getPayQrcode } from '@/api/pdfPay'
import client from '@/client/'
import { mapGetters, mapActions } from 'vuex'
import {
  PAGE_NUM, LOGIN_SERVICE, REPORT_RELATED, UNI_FROM, OCPC_CONVERT_TYPE,
  PAY_CHANNEL, PAY_TYPE, PRIVACYLINK, SUBSCRIPTION_POLICY, UNFINISH_PAY_LIST
} from '@/config/dataMap'
import QrcodeVue from 'qrcode.vue'
import Cookie from 'js-cookie'
import { updateConvertData } from '@/api/login'
import animate from '@/utils/animate'
import { useEasyCounter } from '@crab/veekd'
import { easyCounterReport } from '@/utils/report'
import { getCommon, genMidasPayUrl } from '@/services/pay/h5'
import { getUnpaidGuideInfo, setUnpaidGuideInfo } from '@/utils/sessionStorage'

export default {
  name: 'PdfCommonPayModule',
  components: {
    QrcodeVue,
  },
  props: {
    paySuccessTip: {
      type: String,
      default: ''
    },
    noRefresh: {
      type: Boolean,
      default: false
    },
    chargeType: {
      type: Array,
      default: function () {
        return [1]
      }
    },
    // 是否走ABtest套餐. 目前只有极光PDF会员使用
    hasAbTest: {
      type: Boolean,
      default: false
    },
    // 是否为米大师道具直购 -（全文翻译加购）
    isTool: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: 0, // 当前选中是哪个价格 默认选中第一项
      payType: PAY_CHANNEL.SOGOU, // 当前选中是哪种支付方式
      priceId: -1, // 当前支付是哪种会员，settings接口的id
      settings: [],
      touristQrText: '',
      qrText: '',
      qrRender: false,
      orderId: '', // 订单id
      loopPayResultTimer: null, // 轮询支付结果定时器
      timer: null,
      renew: true,
      aliUrl: '',
      renewSettings: null,
      isExpires: false,
      newAli: true,
      paySettingStatus: 'left',
      countTimer: null,
      coutTimeNum: {
        h: '00',
        m: '00',
        s: '00',
        end: false
      },
      // 支付套餐下方文案样式
      tipClass: ['', 'del'],
      ulTransForm: 0,
      isDiamondHoverTip: false,
      diamondSetting: null,
      qrCodeReportObj: { // 二维码展示上报,字段参考duba_tech_monitor_qrcode表
        action: 1,
        qr_type: 1,
        err_code: ''
      },
      pageSize: 4,
      currentPage: 1,
      cancel: null,
      serverTime: 0, // 记录获取支付套餐api的服务器当前时间戳，用于支付中间页查看用户是否已支付api的入参
      privacyLink: PRIVACYLINK,
      subscribePolicy: SUBSCRIPTION_POLICY, // 订阅协议
      certificateId: '', // 中间页支付认证ID
    }
  },
  watch: {
    async renew () {
      const { isActive } = this
      await this.getPayInfo()
      if (this.isActive > this.settingsShow.length - 1) {
        this.isActive = this.settingsShow.length - 1
      }
      if (isActive !== false) {
        this.getQrCodeByServer(true)
      }
    },
    settingsShow (list) {
      // 套餐列表刷新，默认选择第一个
      // this.$nextTick(() => {
      //   this.selPrice(0, list[0].id, list[0])
      // })
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'openId',
      'loginStatus',
      'isMember',
      'userInfo',
      'getClientInstallTime',
      'continuousInfo',
      'isPdfMember',
      'isPdfLifeMember'
    ]),
    total () {
      return (
        (this.settingsShow[this.isActive] &&
          this.settingsShow[this.isActive].current_price) ||
        0
      )
    },
    settingsShow () {
      if (this.continuousInfo?.continuous_status === 2) {
        return this.settings.filter((item) => { return item.is_continuous !== 1 })
      }
      return this.settings
    },
    priceOff () {
      return this.settingsShow[this.isActive]
        ? this.settingsShow[this.isActive].price -
        this.settingsShow[this.isActive].current_price
        : ''
    },
    selected () {
      return {
        money:
          this.renewSettings && this.renewSettings[this.isActive].id !== 20
            ? this.renewSettings[this.isActive].price -
            this.renewSettings[this.isActive].current_price
            : ''
      }
    },
    isDisabled () {
      // 判断续费按钮是否可点   包年不可点、三年
      return true
    },
    sub_mode () {
      return (
        this.settingsShow[this.isActive] && this.settingsShow[this.isActive].id
      )
    },
    isNewUser () {
      return this.userInfo
        ? this.userInfo.latest_order_type <= 0
        : true
    },
    continuousText () {
      const payPackage = this.settingsShow[this.isActive]
      if (payPackage?.is_continuous) {
        return `会员到期当天以${payPackage.current_price}元/${payPackage.month_length}个月自动续费，可随时关闭`
      }
      return ''
    },
    pageCount () {
      const len = this.settingsShow.length
      if (len) {
        return Math.ceil(len / this.pageSize)
      }
      return 1
    },
    // 是否会员
    isVip () {
      return this.isPdfMember || this.isPdfLifeMember || this.isMember
    }
  },

  async created () {
    await this.getPayInfo()

    // url带了参数，自动选中那个套餐
    if (this.$route.query.selected_month_length) {
      this.settingsShow.forEach((item, index) => {
        if (item.month_length == this.$route.query.selected_month_length) {
          this.isActive = index
          if (index > 3) {
            this.paySettingStatus = 'right'
          }
        }
      })
    }

    this.getQrCodeByServer()

    this.$EventBus.$on('logout', () => {
      this.clearLoopTimer()
      // this.isActive = false;
      this.getPayInfo()

      this.qrCodeReportObj.qr_type = REPORT_RELATED.qr_type.login
      this.qrCodeReportObj.err_code = ''
      this.qrCodeLoadedReport(REPORT_RELATED.qr_show.success)
    })
    // this.reportABTest({ showed: 1 })
  },
  beforeDestroy () {
    this.clearLoopTimer()
  },
  methods: {
    ...mapActions('user', ['refresh']),
    selPrice (idx, id, i) {
      this.isActive = idx

      // 避免登录状态下，continuousInfo数据更新导致两次上报问题
      if (this.loginStatus) {
        this.continuousInfo.name != undefined && this.$emit('changePay', { idx: i.id, id, sub_mode: i.id })
      } else {
        this.$emit('changePay', { idx: i.id, id, sub_mode: i.id })
      }
      if (this.priceId === id) {
        return
      }
      this.priceId = id
      this.qrCodeReportObj.action = REPORT_RELATED.action.package_click
      this.getQrCodeByServer()
    },
    changePaySettingStatus (idx) {
      const showCount = 5
      const total = this.settingsShow.length
      const overstepCount = total - showCount
      const payImteWidth = 110
      const paddingRight = 20
      const rankBtnWidth = 37
      let transForm = 0
      this.clear()
      this.timer = setTimeout(() => {
        if (idx == 0) {
          this.paySettingStatus = 'left'
        } else {
          this.paySettingStatus = 'right'
          transForm =
            overstepCount * payImteWidth +
            (overstepCount - 1) * paddingRight +
            rankBtnWidth -
            20
        }

        this.ulTransForm = `transform: translateX(${-transForm}px);`
      }, 200)
    },
    async selPayType (idx) {
      const { renew } = this
      this.clearLoopTimer()
      if (renew) {
        await this.getPayInfo()
      }
      this.$emit('changePayType', {
        idx: this.settingsShow[idx].id,
        active: this.settingsShow[idx].id
      })

      const reportAction = idx === 1 ? REPORT_RELATED.action.choose_weChat_pay : REPORT_RELATED.action.choose_alipay
      this.qrCodeReportObj.action = reportAction

      this.getQrCodeByServer(true)
    },
    /* eslint-disable-next-line */
    async getPayInfo() {
      const { openId, renew } = this
      const is_continuous = renew ? 1 : 0
      const show = await this.getPayInfoShow()

      const data = await getPaySetting({
        open_id: openId,
        is_continuous,
        time_type: 0,
        show,
        is_all: 1,
      })
      const result = data
      if (result) {
        let pay_price_settings = result.pay_price_settings
        pay_price_settings = pay_price_settings.map(item => {
          if (item.month_length === 1) {
            item.title_img = !this.isNewUser ? item.title_img : ''
          }
          return item
        })
        this.settings = pay_price_settings
        // 保存自动续费的套餐列表
        if (renew) {
          this.renewSettings = pay_price_settings
        }

        // 钻石套餐
        this.settings.forEach(item => {
          if (item.month_length === 1200) {
            this.diamondSetting = item
          }
        })
        // 存储服务器当前时间戳
        this.serverTime = result.server_time ? result.server_time : 0
      }
      // 判断是否开始倒计时
      for (let i = 0; i < this.settingsShow.length; i++) {
        if (this.settingsShow[i].title_type === 2) {
          this.startCountTime(this.settingsShow[i].end_time, result.server_time)
        }
      }
    },
    async getQrCodeByServer (bool) {
      const hasQrcode = this.$slots?.hasQrcode
      if (!this.loginStatus || !this.openId || !this.settingsShow[this.isActive]?.id) {
        // 不展示二维码不上报
        if (!hasQrcode) {
          this.qrCodeLoadedReport(REPORT_RELATED.qr_show.success)
        }
        return
      }

      this.qrCodeReportObj.qr_type = REPORT_RELATED.qr_type.pay
      const { install_time_sec, install_days } = await this.getClientInstallTime

      const codeParams = {
        pay_setting_id: this.settingsShow[this.isActive].id,
        pay_from: PAGE_NUM[this.$route.name],
        pay_channel: this.payType,
        show_from: Number(Cookie.get('show_from')) || 0,
        pay_type: PAY_TYPE.SOGOU_WX_WEB,
        order_from: 1,
        uni_from: UNI_FROM.PDF_PAY,
        install_time_sec,
        install_days,
        isTool: this.isTool,
        pay_setting_name: this.settingsShow[this.isActive].name,
        pay_setting_price: this.settingsShow[this.isActive].current_price,
      }
      this.genH5PayCode(codeParams)
    },

    /**
     * 生成h5支付中间页二维码
     * @param {object} paramsObj
     * */
    genH5PayCode (paramsObj) {
      this.isExpires = false
      try {
        const H5Params = {
          common: getCommon(),
          client_extra: {
            payParams: paramsObj,
            common: getCommon()
          },
          permission_setting_id: paramsObj.pay_setting_id
        }
        this.qrCodeLoadedReportFunc(REPORT_RELATED.qr_show.api_begin)
        easyCounterReport('pay_code_api_begin')

        cacheH5PageReportParams(H5Params).then(async res => {
          if (res.resp_common.ret !== 0) {
            this.isExpires = true
            this.$toast('获取支付二维码异常，稍后请重试')
            easyCounterReport('pay_code_show_fail')
            return
          }
          this.certificateId = res.certificate

          const url = genMidasPayUrl(res.certificate)
          url && this.renderQrCode(url, '')

          // 过期时间到了后设置二维码过期
          setTimeout(() => {
            this.loopPayResultExpire()
          }, Number(res.expire_sec) * 1000)
        })
      } catch (err) {
        console.log('generate short url error:', err)
        this.$toast('获取支付二维码异常，稍后请重试')
      }
    },

    /**
     * 渲染二维码
     * @param {string} codeUrl
     * @param {string} orderId
     */
    renderQrCode (codeUrl, orderId) {
      this.qrCodeLoadedReportFunc(REPORT_RELATED.qr_show.api_success)
      // 支付码请求成功上报 - easyCounter
      easyCounterReport('pay_code_api_success')
      this.qrText = codeUrl
      this.orderId = orderId
      this.qrRender = true
      this.renderQrcallback()
      this.$emit('qrChange', { id: this.settingsShow[this.isActive].id })

      const qrShow = this.qrText ? REPORT_RELATED.qr_show.success : REPORT_RELATED.qr_show.fail

      try {
        this.qrText ? easyCounterReport('pay_code_show_success') : easyCounterReport('pay_code_show_fail')
      } catch (e) {
        console.error(' == easyCounterReport error == ', e)
      }

      // 不展示二维码不上报
      const hasQrcode = this.$slots?.hasQrcode
      if (!hasQrcode) {
        this.qrCodeLoadedReportFunc(qrShow)
      }
    },

    /* eslint-disable-next-line */
    isRenderData(data) {
      try {
        if (data && data.resp_common && data.resp_common.ret === 0) {
          return data
        }
        this.errerTips()

        return false
      } catch (e) {
        this.errerTips()
        this.qrRender = false
      }
    },

    qrCodeLoadedReport (qr_show, pay_way = 0) {
      const curObj = {
        payid: this.settingsShow[this.isActive]?.id || 0,
        payid_time: this.settingsShow[this.isActive]?.month_length || 0,
        payway: pay_way || this.payType,
        qr_show
      }
      client.techMonitor.REPORT.fetmReportQrcode(Object.assign({}, curObj, this.qrCodeReportObj))
    },

    qrCodeLoadedReportFunc (qrShow) {
      try {
        const payWayReport = this.isTool ? 9 : 8
        this.qrCodeLoadedReport(qrShow, payWayReport)
      } catch (error) {
        console.error(' == qrCodeLoadedReportFunc error == ', error)
      }
    },

    errerTips () {
      this.$toast('获取支付信息异常')
    },
    login (idx) {
      if (this.loginStatus) {
        this.getQrCodeByServer()
        return
      }
      client.common.API.userLogin({ url: LOGIN_SERVICE.url })
      this.$emit('login', { idx: idx })
    },
    renderQrcallback () {
      this.clearLoopTimer()
      // 支付二维码生成完成，开始轮询支付结果接口
      let hour = 3600
      const time = 3

      this.loopPayResultTimer = setInterval(() => {
        hour = hour - time
        // 一小时有效期
        if (hour > 0) {
          getH5PayResult({
            start_timestamp: this.serverTime,
            certificate: this.certificateId
          }).then(data => {
            this.payOfSuccess(data)
          })
        } else {
          this.loopPayResultExpire()
        }
      }, time * 1000)
    },

    /**
     * 获取支付成功后的逻辑处理
     * @param {object} data
     */
    payOfSuccess (data) {
      const STATUS_CODE = {
        success: 0,
        expire: 7002001
      }
      const result = this.isRenderData(data)

      try {
        const hasCacheUnpaidGuide = getUnpaidGuideInfo()
        if (result.data.is_user_scanned && hasCacheUnpaidGuide === UNFINISH_PAY_LIST.INIT_STATUS && !this.isVip) {
          // 标识已经扫码完成
          setUnpaidGuideInfo(UNFINISH_PAY_LIST.HAVE_SCAN_QRCODE)
        }
      } catch (e) {
        console.error(' == isScan error == ', e)
      }

      // 0订单支付成功,7001001为支付失败,7001002未支付,7001003支付关闭,7001005没有此订单
      const status = result.data && result.data.status
      if (status === STATUS_CODE.success) {
        this.clearLoopTimer()
        // 刷新用户状态，跳转到首页
        client.common.API.paySuccess({ token: this.token, open_id: this.openId })
        if (!this.noRefresh) {
          this.refresh({
            token: this.token,
            open_id: this.openId,
            webRefresh: 1
            /* eslint-disable-next-line */
          }).then(() => {
            this.paySuccessCallback()
          })
        } else {
          this.paySuccessCallback()
        }
      } else if (status === STATUS_CODE.expire) {
        this.loopPayResultExpire()
        this.getPayInfo()
      }
    },

    // 轮询二维码过期或者轮询支付结果过期
    loopPayResultExpire () {
      this.clearLoopTimer()
      this.isExpires = true
      this.qrCodeReportObj.qr_type = REPORT_RELATED.qr_type.expire
      this.qrCodeLoadedReport(REPORT_RELATED.qr_show.success)
    },
    paySuccessCallback () {
      client.common.API.getOcpcUrl().then(res => {
        updateConvertData({
          conversion_info: {
            long_code: res.logidUrl,
            convert_type: OCPC_CONVERT_TYPE.BUY,
            user_type: res.userType > 0 ? res.userType : 1,
          }
        })
      })

      this.$EventBus.$emit('paysuccess')
      this.$emit('paySuccess', {
        month_length: this.settingsShow[this.isActive].month_length
      })

      // 优先弹传入的支付成功提示
      if (this.paySuccessTip) {
        this.$toast(this.paySuccessTip, { duration: 5000 })
      } else {
        this.$toast('支付成功', { duration: 5000 })
      }

      this.getPayInfo()

      // 支付成功后初始化未支付引导状态 - 实现同一个会员中心进行只弹一次引导支付窗口
      setUnpaidGuideInfo(UNFINISH_PAY_LIST.HAVE_OPEN_UNFINISH_MODULE)
      easyCounterReport('pay_code_finish')
    },
    clearLoopTimer () {
      if (this.loopPayResultTimer) clearInterval(this.loopPayResultTimer)
    },
    clear () {
      clearTimeout(this.timer)
      this.timer = null
    },
    changeRenew () {
      if (this.isDisabled) {
        return
      }
      this.renew = !this.renew
      this.$emit('changeRenew', this.renew)
    },
    toXieyi () {
      this.$emit('toXieyi')
      if (!this.isDisabled) {
        window.open('http://www.ijinshan.com/protocol/autorenewagreement.shtml')
      }
    },
    startCountTime (endTime, nowTime) {
      clearInterval(this.countTimer)
      let expiresTime = endTime - nowTime
      this.coutTimeNum = Object.assign(
        this.coutTimeNum,
        this.countTime(expiresTime--)
      )
      this.countTimer = setInterval(() => {
        if (expiresTime >= 0) {
          this.coutTimeNum = Object.assign(
            this.coutTimeNum,
            this.countTime(expiresTime--)
          )
        } else {
          this.coutTimeNum.end = true
          clearInterval(this.countTimer)
          this.countTimer = null
        }
      }, 1000)
    },
    countTime (expiresTime) {
      function dealNum (num) {
        return num >= 10 ? num : `0${num}`
      }
      const h = dealNum(Math.floor(expiresTime / 3600))
      const m = dealNum(Math.floor((expiresTime - h * 3600) / 60))
      const s = dealNum(expiresTime - h * 3600 - m * 60)
      return {
        h,
        m,
        s
      }
    },
    changeIsDiamondHoverTip (flag) {
      this.isDiamondHoverTip = flag
      this.$emit('changeIsDiamondHoverTip', flag)
    },

    /** 获取支付套餐show值 */
    getPayInfoShow () {
      return this.chargeType
    },

    /** 套餐列表上一页 */
    prev () {
      this.currentPage = this.currentPage - 1
      const { scrollLeft: start } = this.$refs.listRef
      const end = Math.max(0, start - 652)
      if (this.cancel) {
        // 取消之前的动画
        this.cancel()
      }
      this.cancel = animate(start, end, value => (this.$refs.listRef.scrollLeft = value))
      client.home.REPORT.reportHomeOperate({ main_click: 90 })
      useEasyCounter().count('pdfvip_pricing_click_prev', 1, { tryno: Cookie.get('tryno') || undefined })
    },
    /** 套餐列表下一页 */
    next () {
      const { scrollLeft: start, scrollWidth } = this.$refs.listRef
      const end = start + Math.min(scrollWidth - this.currentPage * 652, 652)
      this.currentPage = this.currentPage + 1
      if (this.cancel) {
        // 取消之前的动画
        this.cancel()
      }
      this.cancel = animate(start, end, value => (this.$refs.listRef.scrollLeft = value))
      client.home.REPORT.reportHomeOperate({ main_click: 89 })
      useEasyCounter().count('pdfvip_pricing_click_next', 1, { tryno: Cookie.get('tryno') || undefined })
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixins.scss';

.new-pay {

  @mixin pay_price_bg($bg: #fff,
    $bcor: #d9d9d9,
    $hover_bcor: #adc4d9,
    $ac_bcor: #eb5350,
    $ac_shadow: #e8f2fc,
    $span_cor: #333) {
    border-radius: 4px;
    vertical-align: middle;
    height: 90px;
    line-height: 20px;
    background: $bg;
    cursor: pointer;
    border: solid 1px $bcor;

    // cursor: pointer;
    &:hover {
      border: solid 1px $ac_bcor;
    }

    &.active {
      border: solid 1px transparent;
      box-shadow: 0 0 0 2px red;
      height: 86px;
      border-radius: 5px;
      margin-top: 2px;

      .active-hook {
        position: absolute;
        right: -2px;
        bottom: 0px;
        width: 17px;
        height: 17px;
        background: #fffcef url(~@/assets/images/pay-select.png) no-repeat right bottom;
      }

      .current-price {
        padding-top: 7px;
      }
    }

    .tit-img {
      position: absolute;
      left: -11px;
      top: -17px;
      width: 157px;
      height: 44px;
    }

    .tit-img-3 {
      position: absolute;
      left: -4px;
      top: -22px;
      height: 29px;

      img {
        height: 100%;
      }
    }

    .tit-img-4 {
      height: 26px;
      position: absolute;
      top: -19px;
      left: -4px;

      img {
        height: 100%;
      }
    }

    .tit-time-limit {
      .time-limit {
        color: #de461e;
        height: 26px;
        width: 112px;
        padding-left: 4px;
        box-sizing: border-box;
        position: absolute;
        left: -4px;
        top: -19px;
        font-size: 12px;
      }

      span {
        display: inline;
        font-size: 12px;
        line-height: 24px;
        color: #de461e;
      }

      .tit {
        line-height: 20px;
      }

      .time-span {
        color: #fff;
        display: inline-block;
        width: 18px;
        text-align: center;
        box-sizing: border-box;
        background: #dc320a;
        border-radius: 2px;
        margin-top: -3px;
        line-height: 16px;
        vertical-align: middle;
        overflow: hidden;
      }

      .time-em {
        display: inline-block;
        width: 8px;
        font-style: normal;
      }
    }

    span {
      &.tit {
        position: absolute;
        float: left;
        color: #fff;
        font-size: 12px;
        height: 26px;
        line-height: 24px;
        top: -19px;
        left: -4px;
      }

      &.tit2 {
        display: inline-block;
        margin-top: 35px;
        font-size: 14px;
        max-height: 18px;
        max-width: 96px;
        overflow: hidden;
      }

      &.tit3 {
        margin: 5px;

        font-size: 14px;
        position: relative;

        del {
          color: #909090;
        }

        &.show-next {
          font-size: 12px;
          line-height: 1;
          margin-top: 0;
          color: #909090;
          margin-top: 2px;

          p {
            margin-top: 5px;
          }
        }
      }

      &.price {
        display: inline-block;
        color: #de461e;
        margin-top: 30px;
        max-width: 96px;

        em {
          font-style: normal;
          font-size: 24px;
          vertical-align: 1px;
        }

        letter-spacing: -1px;
        font-size: 28px;
      }

      display: block;
      color: $span_cor;
    }
  }

  ul {
    overflow: visible;
    transition: 0.35s 0s ease;
    display: flex;
    padding-left: 3px;
    padding-right: 5px;
    flex-grow: 1;

    li {
      text-align: center;
      position: relative;
      flex: 1 118px;

      &>div {
        @include pay_price_bg;
      }
    }
  }

  .bottom {
    position: relative;
    height: 128px;
    width: 642px;
    margin-left: 24px;
    box-sizing: border-box;
    font-size: 12px;
    background: #f4f6fa;

    .pay_type {
      float: left;
      margin-bottom: 12px;

      dt {
        font-size: 16px;
        padding-bottom: 10px;
      }

      dd {
        width: 266px;
      }
    }

    dt {
      color: #333;
      font-size: 14px;
      margin-bottom: 2px;
      padding-left: 6px;
    }

    dd {
      font-size: 12px;
      color: #8d8e93;
    }

    p {
      padding-left: 6px;
    }

    span.total {
      color: #de461e;
      font-size: 36px;
      padding: 0 5px;

      em {
        font-style: normal;
        font-size: 20px;
        margin-right: -1px;
        vertical-align: 1px;
      }

      .total_off {
        color: #8d8e93;
        font-size: 12px;
      }

      letter-spacing: -1px;
    }

    .ali-total {
      font-size: 48px;
      color: #de461e;
      position: absolute;
      bottom: 41px;
      left: 15px;
      line-height: 1;
    }

    .wechatpay {
      display: block;
      width: 158px;
      height: 38px;
    }

    .diamond-desc {
      margin: 17px 0 0 14px;
      font-size: 14px;
      color: #545454;

      p {
        margin-bottom: 2px;
        padding-left: 0;
      }

      i {
        width: 4px;
        height: 4px;
        background: rgba(141, 142, 147, 1);
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
      }

      .title {
        font-size: 14px;
        color: #b07400;
        background: #fff1ce;
        border: 1px solid #cba864;
        border-radius: 2px;
        width: 79px;
        height: 13px;
        line-height: 13px;
        padding: 2px;
      }
    }
  }

  .notice {
    color: #8d8e93;
    margin-bottom: 18px;
    height: 16px;
  }

  .dl_total {
    float: left;
    padding-top: 14px;
    dd {
      margin-top: 2px;
      padding-left: 26px;
      .privacy-link {
        padding-left: 10px;
        a {
          color: #BD6603;
        }
      }
    }
    :first-child {
      margin-top: unset;
    }
  }

  .qrcode {
    float: left;
    color: #8d8e93;
    padding-top: 8px;
    text-align: center;
    width: 110px;
    height: 110px;
    position: relative;

    img {
      width: 110px;
      height: 110px;
      margin-bottom: 10px;
      cursor: pointer;
    }

    img,
    span {
      display: block;
    }
  }

  .pay-title {
    padding-left: 10px;

    em {
      margin: 0 4px;
      font-style: normal;
      color: #de461e;
    }
    a {
      color: #BD6603;
    }
  }

  .pay-list {
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    // width: 100%;
    width: 686px;
    padding-left: 21px;
    padding-right: 18px;
    box-sizing: border-box;
  }

  .pay-wrap {
    width: 100%;
    position: relative;
    padding-top: 43px;
    padding-left: 2px;
    padding-right: 1px;
    overflow-x: scroll;
    display: flex;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .arrow-button {
    cursor: pointer;
    position: absolute;
    width: 8px;
    height: 18px;
    top: 80px;
    z-index: 1;
  }

  .arrow-left {
    left: 10px;
  }

  .arrow-right {
    right: 4px;
  }

  .pay-item-w {
    margin-bottom: 30px;
  }

  .pay-item {
    min-width: 150px;
    margin-right: 13px;

    &:last-of-type {
      margin-right: 0px;
    }
  }

  .current-price {
    padding-top: 9px;
    font-size: 28px;
    color: #de461e;
    line-height: 1;

    em {
      font-size: 18px;
      font-style: normal;
    }
  }

  .time-line {
    font-size: 14px;
    color: #545454;
    margin-top: 6px;
    line-height: 1;
  }

  .linear {
    width: 100%;
    position: absolute;
    bottom: 27px;
    height: 1px;
    background: linear-gradient(to right,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 10%,
        rgba(157, 157, 157, 0.3) 20%,
        rgba(157, 157, 157, 0.4) 30%,
        rgba(157, 157, 157, 0.5) 40%,
        rgba(157, 157, 157, 0.8) 50%,
        rgba(157, 157, 157, 0.5) 60%,
        rgba(157, 157, 157, 0.4) 70%,
        rgba(157, 157, 157, 0.3) 80%,
        rgba(0, 0, 0, 0) 90%,
        rgba(0, 0, 0, 0) 100%);
  }

  .tip {
    font-size: 14px;
    color: #888;
    line-height: 25px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    &.del {
      text-decoration: line-through;
    }
  }

  .renew {
    padding-left: 24px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;

    a {
      color: #bca499;
      cursor: pointer;
    }

  }

  .checkbox {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(~@/assets/images/sprite.png) no-repeat;
    background-position: -166px -331px;
    margin-right: 10px;
    position: relative;
    top: 1.5px;
    cursor: pointer;

    &.isActive {
      background-position: -152px -331px;
    }
  }

  .ali-pay {
    position: absolute;
    right: 70px;
    bottom: 26px;
    text-align: center;
    color: #8d8e93;
    font-size: 14px;
    line-height: 1;

    span {
      color: #de461e;
    }
  }

  .pay-btn {
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 100px;
    cursor: pointer;
    color: #11a9eb;
    border: 1px solid #11a9eb;
    border-radius: 5px;
    margin: 0 auto 10px;

    &:hover {
      color: #fff;
      background: #11a9eb;
    }
  }

  .is-disabled {
    color: #cacaca;
    cursor: not-allowed;
    visibility: hidden;

    .checkbox {
      cursor: not-allowed;
      background: url(~@/assets/images/grey-checkbox.png) no-repeat center center;
    }

    a {
      color: #cacaca;
      cursor: not-allowed;
    }
  }
}

.promotion-arrow {
  width: 14px;
  height: 131px;
  position: absolute;
  top: 20px;
  background: url(~@/assets/images/promotion-left.png) no-repeat left bottom;
  cursor: pointer;
  background-color: #fff;
  z-index: 1;
  top: 6px;

  &:hover {
    background-position-x: center;
  }

  &:active {
    background-position-x: right;
  }
}

.promotion-left {
  left: 28px;

  &::after {
    width: 7px;
    background: #fff;
    content: '';
    position: absolute;
    left: 14px;
    top: 0;
    height: 100%;
    box-shadow: 6px 0px 7px rgba(255, 255, 255, 1);
  }
}

.promotion-right {
  background-image: url(~@/assets/images/promotion-right.png);
  right: 15px;

  &::after {
    width: 17px;
    background: #fff;
    content: '';
    position: absolute;
    left: 14px;
    top: 0;
    height: 100%;
    z-index: -1;
  }
}

.tip-wrap {
  position: absolute;
  top: 142px;
  right: 12px;
  z-index: 2;
  width: 192px;
  height: 59px;
  box-sizing: border-box;
  padding: 11px 14px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 2px;
  font-size: 14px;
  color: #545454;
  font-weight: bold;

  .arrow {
    position: absolute;
    right: 50px;
    top: -12px;
    width: 0;
    height: 0;
    border-width: 6px;
    border-color: transparent transparent #ddd transparent;
    border-style: solid;
    overflow: hidden;
  }

  .arrow-white {
    border-bottom-color: #fff;
    right: 51px;
    border-width: 5px;
    top: -9px;
  }
}

.diamond-icon {
  display: inline-block;
  width: 30px;
  height: 23px;
  margin: -5px 10px 0;
  vertical-align: middle;
  background: url(~@/assets/images/diamond/diamond.png) no-repeat 0 0;
}

.bottom-desc {
  padding-top: 0px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  height: 35px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 18px;
  color: #888;
}
</style>
